const bgImg1080 = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAABXCAYAAAAERWXPAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyhpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQ1IDc5LjE2MzQ5OSwgMjAxOC8wOC8xMy0xNjo0MDoyMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTkgKE1hY2ludG9zaCkiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6RDRGNDE4MkM0RTFEMTFFOUFEMzRBNTVFMkM5NzFBNDEiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6RDRGNDE4MkQ0RTFEMTFFOUFEMzRBNTVFMkM5NzFBNDEiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDoyN0MxOUE3QjRFMUMxMUU5QUQzNEE1NUUyQzk3MUE0MSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDoyN0MxOUE3QzRFMUMxMUU5QUQzNEE1NUUyQzk3MUE0MSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PhecyQ8AAABVSURBVHja7NPBDQAQEEVBRBuq0JFaXfVECQ57kJifuL5EspPbmD0FrqTgCT4YrOet/75MiiAppAiSQoogKaQIkkKKICmkuENSSHE2gqQ4G8HrbQEGALBeCkS/F8LEAAAAAElFTkSuQmCC';
// const color1080 = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAABXCAYAAAAERWXPAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyhpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQ1IDc5LjE2MzQ5OSwgMjAxOC8wOC8xMy0xNjo0MDoyMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTkgKE1hY2ludG9zaCkiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6RDRGNDE4MzA0RTFEMTFFOUFEMzRBNTVFMkM5NzFBNDEiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6RDRGNDE4MzE0RTFEMTFFOUFEMzRBNTVFMkM5NzFBNDEiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpENEY0MTgyRTRFMUQxMUU5QUQzNEE1NUUyQzk3MUE0MSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpENEY0MTgyRjRFMUQxMUU5QUQzNEE1NUUyQzk3MUE0MSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PvJ8wbAAAABTSURBVHja7NOxCQAgDEVBI67hcs7qXuoIFikE74PtAyEXfcxVEldL8gQfDLbz4r8vkyJICimCpJAiSAopgqSQIkgKKe6QFFKcjSApzkbweluAAQCQkgsQ1llfMwAAAABJRU5ErkJggg==';
const color1080 = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAABXCAYAAAAERWXPAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyhpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQ1IDc5LjE2MzQ5OSwgMjAxOC8wOC8xMy0xNjo0MDoyMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTkgKE1hY2ludG9zaCkiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6Q0NEMTUwQTk0RUNDMTFFOUFEMzRBNTVFMkM5NzFBNDEiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6Q0NEMTUwQUE0RUNDMTFFOUFEMzRBNTVFMkM5NzFBNDEiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpDQ0QxNTBBNzRFQ0MxMUU5QUQzNEE1NUUyQzk3MUE0MSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpDQ0QxNTBBODRFQ0MxMUU5QUQzNEE1NUUyQzk3MUE0MSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PgU9wDcAAACqSURBVHjaYpRNOvKfgYqABYipbuC/kefCwe9lLkoMeDTXGoXPxEBlQHUDQV5+R4kBcslHMQz8O/LSIdUNHPxhqDDycsrVkZdT/o4aSLGBNiMvp+wY9DmF6gb+Gc0pFBsYPfJyyoxBn1NGYMIe/F6uGXk5pXy0ThmtU0g3cM7Iyynh1M4po92KkWDgrpGXU6wHfU4ZgSNLg9+Fl0deTlEdeTlldMaHMgAQYAAPDViY39ZP5gAAAABJRU5ErkJggg==';

let bgImg = 'https://s3plus.meituan.net/v1/mss_78d1aa5426c546bfa023ca0cacfa2cd1/distribute/2accb8ac-b025-4b94-a81c-70f53f8f9e64_1553569568423?filename=bgImg.png';
let color1Img = 'https://s3plus.meituan.net/v1/mss_78d1aa5426c546bfa023ca0cacfa2cd1/distribute/f7bd0eef-e839-4ec1-87c2-61ca0fa6491c_1553569573061?filename=color1.png';
let color2Img = 'https://s3plus.meituan.net/v1/mss_78d1aa5426c546bfa023ca0cacfa2cd1/distribute/48a38d74-bde4-4087-bafd-1d2c2ea83663_1553569576809?filename=color2.png';

let axisColor = '#1D62C4';
let textColor = '#1D62C4';

if (window._screenType === '2160') {
    axisColor = '#3E79D4';
    textColor = '#3E79D4';
} else {
    bgImg = bgImg1080;
    color1Img = color1080;
    color2Img = color1080;
}
let ecPictorialBar = ({ dom, data, echarts }) => {
    let myChart = echarts.init(dom);
    function resizeChartStackArea() {
        if (myChart) {
            myChart.resize();
        }
    }
    // 销毁事件
    ecPictorialBar.destroy = () => {
        echarts.dispose(dom);
        window.removeEventListener('resize', resizeChartStackArea);
    };
    window.addEventListener('resize', resizeChartStackArea);
    let scale = window._scale || 1;

    // data.forEach((item) => {
    //     item.orgData = item.value;
    //     // x映射到0-1区间，取 y = x 的 4 次方，幂 越大，曲线越抖，数值区分越明显
    //     item.value = Math.pow(item.value / 100, 4);
    // });
    let bgData = data.map((item) => {
        return {
            value: 100,
            orgData: item.orgData,
            name: item.name
        };
    });

    let color1Data = data.map((item, index) => {
        if (index % 2 === 0) {
            return item;
        }
        return {
            value: 0,
            orgData: item.orgData,
            name: item.name
        };
    });
    let color2Data = data.map((item, index) => {
        if (index % 2 === 1) {
            return item;
        }
        return {
            value: 0,
            orgData: item.orgData,
            name: item.name
        };
    });

    let options = {
        // backgroundColor: '#031f2d',
        tooltip: {
            formatter: function(params, ticket, callback) {
                // return `${params.data.name}: ${params.data.orgData}%`;
                return `${params.data.name}: ${params.data.value}%`;
            },
            textStyle: {
                fontSize: scale * 14
            },
        },
        grid: {
            top: 10,
            left: 8,
            right: 40,
            bottom: 0,
            containLabel: true
        },
        xAxis: [{
            type: 'category',
            nameLocation: 'middle',
            data: (function(data) {
                var arr = [];
                data.forEach(function(items) {
                    arr.push(items.name);
                });
                return arr;
            })(data),
            boundaryGap: false,
            // boundaryGap: ['10%', '10%'],
            splitLine: {
                show: false
            },
            axisLine: {
                show: false
            },
            axisTick: {
                show: false
            },
            axisLabel: {
                textStyle: {
                    fontSize: 12 * scale,
                    color: textColor
                },
                interval: 0,
            }
        }],
        yAxis: [{
            type: 'value',
            show: false,
            splitLine: {
                show: false
            },
            axisLine: {
                show: false
            },
            axisLabel: {
                textStyle: {
                    color: axisColor,
                    fontSize: 14 * scale
                }
            },
        }],
        series: [
            // 背景
            {
                name: 'bg',
                type: 'pictorialBar',
                barWidth: '60%',
                barCategoryGap: '40%',
                // barGap: '0%',
                silent: true,
                animation: false,
                symbol: 'image://' + bgImg,
                symbolClip: false,
                symbolBoundingData: 100,
                symbolSize: ['100%', '100%'],
                data: bgData
            },
            {
                name: '数据',
                type: 'pictorialBar',
                barWidth: '60%',
                barGap: '-100%',
                data: color1Data,
                z: 3,
                symbol: 'image://' + color1Img,
                symbolClip: true,
                symbolBoundingData: 100,
                symbolSize: ['100%', '100%']
            },
            {
                name: '数据',
                type: 'pictorialBar',
                barWidth: '60%',
                barGap: '-100%',
                data: color2Data,
                z: 3,
                symbol: 'image://' + color2Img,
                symbolClip: true,
                symbolBoundingData: 100,
                symbolSize: ['100%', '100%']
            },
        ]
    };

    myChart.setOption(options);
    return ecPictorialBar;

};
export default ecPictorialBar;
